if (!customElements.get("product-form")) {
  // Create a class for the element
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.form.querySelector("[name=id]").disabled = false;
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.cart = document.querySelector("cart-drawer");
      this.submitButton = this.querySelector('[type="submit"]');

      this.hideErrors = this.dataset.hideErrors === "true";
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute("aria-disabled") === "true") return;

      this.handleErrorMessage();

      this.submitButton.setAttribute("aria-disabled", true);

      this.querySelector(".quick-add-submit-cart-icon")?.classList.add(
        "hidden"
      );
      this.querySelector(".quick-add-submit-spinner")?.classList.remove(
        "hidden"
      );
      this.querySelector(".add-submit-cart-icon")?.classList.add("hidden");
      this.querySelector(".add-submit-spinner")?.classList.remove("hidden");

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            //Error
            console.log("Error", response.message);
            this.querySelector(".quick-add-submit-cart-icon").classList.remove(
              "hidden"
            );
            this.querySelector(".quick-add-submit-spinner").classList.add(
              "hidden"
            );
            this.submitButton.setAttribute("aria-disabled", false);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) {
            //Success
            //console.log("Resp", response);
            this.submitButton.setAttribute("aria-disabled", false);
            let quantityInCart = document.querySelector(".quantity-cart");
            if (quantityInCart != null) {
              quantityInCart.innerHTML = `${response.quantity}`;
            }
            this.error = false;
          }

          this.submitButton.setAttribute("aria-disabled", false);
          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.querySelector(".quick-add-submit-cart-icon")?.classList.remove(
            "hidden"
          );
          this.querySelector(".quick-add-submit-spinner")?.classList.add(
            "hidden"
          );
          this.querySelector(".add-submit-cart-icon")?.classList.remove(
            "hidden"
          );
          this.querySelector(".add-submit-spinner")?.classList.add("hidden");
        });
    }

    handleErrorMessage(errorMessage = false) {
      //TODO: Check for errors
      ///alert("There was an error");
    }
  }

  customElements.define("product-form", ProductForm);
}
